import { Component, OnInit } from "@angular/core";
import { LayoutConfigModel } from "../../../../interfaces/home/layout-config";

import * as objectPath from "object-path";

@Component({
  selector: "subheader",
  templateUrl: "./subheader.component.html",
  styleUrls: ["./subheader.component.css"]
})
export class SubheaderComponent implements OnInit {
  // Public properties
  config: LayoutConfigModel;
  // subheader layout
  layout: string;
  fluid: boolean;
  clear: boolean;

  constructor() {}

  ngOnInit(): void {
    const config = JSON.parse(localStorage.getItem("layoutConfig"));

    this.layout = objectPath.get(config, "subheader.layout");
    this.fluid = objectPath.get(config, "footer.self.width") === "fluid";
    this.clear = objectPath.get(config, "subheader.clear");
  }
}
